// messages.js
export default {
    // The key format should be: 'locale.filename'.
    'de.invoices': require('../../resources/lang/de/invoices.php'),
    'de.attendees': require('../../resources/lang/de/attendees.php'),
    'de.accounting': require('../../resources/lang/de/accounting.php'),
    'de.analysis': require('../../resources/lang/de/analysis.php'),
    'de.waiting_list': require('../../resources/lang/de/waiting_list.php'),
    'de.general': require('../../resources/lang/de/general.php'),
    'de.colors': require('../../resources/lang/de/colors.php'),
    'de.address': require('../../resources/lang/de/address.php'),
    'de.coupons': require('../../resources/lang/de/coupons.php'),
    'de.events': require('../../resources/lang/de/events.php'),
    'de.locations': require('../../resources/lang/de/locations.php'),
    'de.orders': require('../../resources/lang/de/orders.php'),
    'de.organizers': require('../../resources/lang/de/organizers.php'),
    'de.quotas': require('../../resources/lang/de/quotas.php'),
    'de.ticket_types': require('../../resources/lang/de/ticket_types.php'),
    'de.tickets': require('../../resources/lang/de/tickets.php'),
    'de.projects': require('../../resources/lang/de/projects.php'),
    'de.cme': require('../../resources/lang/de/cme.php'),
}
